import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {SidepanelListingSettingsDropdownProps} from 'nav/sidepanel/header/SidepanelListingSettingsDropdown';
import FiltersContainer from 'search/filters/FiltersContainer';
import QueryInput from 'search/QueryInput';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface ListingHeaderProps {
  buttons?: JSX.Element;
  crumbs?: JSX.Element;
  savedSearchHeader?: JSX.Element;
  className?: string;
  isExpanded: boolean;
  hideSectionTabsWhenExpanded?: boolean;
  sectionTabs?: JSX.Element;
  sectionHeader?: JSX.Element;
  filtersContainer?: React.ReactElement<FiltersContainer>;
  multiquerySelector?: JSX.Element;
  queryInput?: React.ReactElement<QueryInput> | null;
  settingsDropdown?: React.ReactElement<SidepanelListingSettingsDropdownProps>;
  showShadow?: boolean;
  showSettingsDropdownInlineInExpandedView?: boolean;
}

function ListingHeader({
  buttons,
  className,
  crumbs,
  filtersContainer,
  hideSectionTabsWhenExpanded,
  isExpanded,
  multiquerySelector,
  queryInput,
  savedSearchHeader,
  sectionHeader,
  sectionTabs,
  settingsDropdown,
  showSettingsDropdownInlineInExpandedView,
  showShadow = true,
}: ListingHeaderProps): JSX.Element {
  return (
    <div
      className={classNames(
        css(!isExpanded && styles.compactWrapper, !isExpanded && showShadow && styles.shadow),
        className
      )}
      {...getTestProps({component: 'ListingHeader', element: 'root'})}
    >
      {(crumbs || buttons) && (
        <div className={classNames(css(styles.crumbsRow), 'u-lr-split')}>
          <div className="u-flex-display u-min-width-zero">
            {crumbs}
            {savedSearchHeader}
          </div>
          <div className="u-flex-none">{buttons}</div>
        </div>
      )}
      {!(isExpanded && hideSectionTabsWhenExpanded) && sectionTabs}
      {isExpanded && sectionHeader}
      <div className={css(isExpanded && styles.queryFiltersRowExpanded, styles.queryFiltersRow)}>
        {queryInput && (
          <div className={css(isExpanded ? styles.queryInputExpanded : styles.queryInputCompact)}>
            {queryInput}
          </div>
        )}
        {!isExpanded ? (
          <div className={css(styles.compactFilters)}>
            {filtersContainer}
            {settingsDropdown}
          </div>
        ) : (
          <div className={css(styles.expandedFilters)}>
            {filtersContainer}
            {showSettingsDropdownInlineInExpandedView && settingsDropdown}
          </div>
        )}
        {!isExpanded && <div className={css(styles.multiquerySelector)}>{multiquerySelector}</div>}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  compactWrapper: {
    flex: 1,
    padding: '16px 12px 0',
  },
  shadow: {
    boxShadow: '0 2px 6px 0 rgba(162,185,190,0.5)',
    zIndex: 1,
  },
  crumbsRow: {
    marginBottom: 16,
    justifyContent: 'space-between',
    display: 'flex',
  },
  queryInputCompact: {
    display: 'flex',
    flex: 1,
    marginBottom: 6,
  },
  queryInputExpanded: {
    display: 'flex',
    flex: 'none',
    marginRight: 6,
    width: 325,
  },
  queryFiltersRowExpanded: {
    alignItems: 'flex-start',
    display: 'flex',
  },
  queryFiltersRow: {
    marginTop: 12,
  },
  compactFilters: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  expandedFilters: {
    display: 'flex',
  },
  chemSearchButton: {
    marginRight: 6,
  },
  multiquerySelector: {
    marginBottom: 6,
  },
});

export default ListingHeader;
